import { testUtils } from './test-utils';
var FakePromise = /** @class */ (function () {
    function FakePromise($q) {
        this.$q = $q;
    }
    FakePromise.prototype.resolvedWith = function (val) {
        return this.$q(function (res) { return res(val); });
    };
    FakePromise.prototype.resolvedWithEmptyObject = function () {
        return this.resolvedWith({});
    };
    FakePromise.prototype.resolvedWithSearchResult = function (items) {
        return this.resolvedWith(testUtils.wrapInSearchResponse(items));
    };
    FakePromise.prototype.resolvedWithEmptySearchResult = function () {
        return this.resolvedWithSearchResult([]);
    };
    FakePromise.prototype.rejectedWith = function (err) {
        return this.$q(function (_, reject) { return reject(err); });
    };
    FakePromise.prototype.rejectedWithErrorCode = function (code, description) {
        return this.rejectedWith({ data: { errorCode: code, errorMessage: description } });
    };
    FakePromise.prototype.rejectedWithHttpError = function (code, payload) {
        return this.rejectedWith({ status: code, data: { payload: payload } });
    };
    FakePromise.resolvedWith = function (val) {
        var promise;
        inject(function ($q) {
            promise = $q(function (resolve) { return resolve(val); });
        });
        return promise;
    };
    FakePromise.rejectedWith = function (val) {
        var promise;
        inject(function ($q) { return promise = $q(function (_, reject) { return reject(val); }); });
        return promise;
    };
    FakePromise.resolvedWithSearchResult = function (val) {
        return this.resolvedWith(testUtils.wrapInSearchResponse(val));
    };
    FakePromise.resolvedWithEmptySearchResult = function () {
        return this.resolvedWithSearchResult([]);
    };
    FakePromise.resolvedWithEmptyObject = function () {
        return this.resolvedWith({});
    };
    return FakePromise;
}());
export { FakePromise };
//# sourceMappingURL=fake-promise.js.map